module.exports = __webpack_public_path__ + "img/0019.e2943724.jpg";